<template>
  <modal width="35" :show-modal="showModal" :id="id" @close-modal="$emit('close-modal')">
    <div class="delete-modal">
      <div class="flex justify-center mb-2">
        <img
          src="@/assets/images/icons/confirm.svg"
          alt="Delete illustration"
          class="img-fluid"
        />
      </div>
      <div>
        <label class="label">Select the reason(s) for cancellation</label>
        <el-select v-model="reason" placeholder="-- Select or Input --">
          <el-option label="Late arrival" value="Late arrival"> </el-option>
          <el-option label="Damaged package" value="Damaged package"> </el-option>
          <el-option label="Rescheduled delivery" value="Rescheduled delivery">
          </el-option>
          <el-option
            label="Delivery to another address"
            value="Delivery to another address"
          >
          </el-option>
          <el-option label="Others" value="others"> </el-option>
        </el-select>
      </div>

      <label class="label">If others, specify.</label>
      <textarea
        name=""
        id=""
        cols="30"
        rows="10"
        class="input"
        style="height: unset"
      ></textarea>
      <p>
        Please note that cancellation is only applicable for bookings that are yet to
        commence. MuleEx will refund for cancelled bookings, but will charge you a flat
        cancelation fee of N750.
      </p>
      <div class="button-wrapper">
        <div>
          <p class="underline cursor-pointer">Go Back</p>
        </div>
        <div>
          <base-button
            text="Cancel Booking"
            :disabled="disableAction"
            @click="$emit('show-cancel-modal')"
          />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>


export default {
  components: {

  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    booking: {
      type: Object,
      required: true,
    },
  },
  computed: {
    disableAction() {
      if (!this.reason.length) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      reason: "",
      loading: false,
      showCancelModal: false,
      id: "cancel-reason",
    };
  },
  methods: {
    completedSubmission() {
      this.reason= ''
      this.$emit("booking-subaction-completed");
      this.$emit("close-modal", this.id);
    },
  },
};
</script>
